import { rem } from 'polished';
import styled from 'styled-components';
import { IColors } from '../../interfaces/Conference';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    position: relative;
    height: ${rem(595)};
    overflow: hidden;
    border-bottom-left-radius: ${rem(12)};
    border-bottom-right-radius: ${rem(12)};
    display: flex;
    flex-direction: column;
`;

export const Image = styled.img`
    position: absolute;
    height: ${rem(595)};
    border-bottom-left-radius: ${rem(12)};
    border-bottom-right-radius: ${rem(12)};
`;

export const Label = styled.span`
    display: block;
    color: ${({ theme }) => theme.colors.white};
    position: relative;
    padding: ${rem(50)} ${rem(30)};
`;

export const Title = styled.h1`
    display: block;
    color: ${({ theme }) => theme.colors.white};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    position: relative;
    font-size: ${({ theme }) => theme.fontSizes.h4};
    line-height: ${rem(30)};
    padding: ${rem(10)} ${rem(30)};

    @media (min-width: ${breakpoints.xs}px) {
        font-size: ${({ theme }) => theme.fontSizes.h2};
        line-height: ${rem(45)};
    }
`;

export const Date = styled.span`
    color: ${({ theme }) => theme.colors.white};
    position: relative;
    display: block;
    font-size: ${({ theme }) => theme.fontSizes.h4};
    padding: ${rem(30)} ${rem(30)} ${rem(5)};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};

    @media (min-width: ${breakpoints.xs}px) {
        font-size: ${({ theme }) => theme.fontSizes.h3};
    }
`;

export const Place = styled.span`
    color: ${({ theme }) => theme.colors.white};
    position: relative;
    display: block;
    padding: 0 ${rem(30)};

    @media (min-width: ${breakpoints.xs}px) {
        padding: 0 ${rem(30)} ${rem(35)} ${rem(30)};
    }
`;

export const Buttons = styled.div`
    position: relative;
    padding: ${rem(20)} ${rem(30)};
`;

const Button = styled.button<{ colors: IColors }>`
    border: none;
    border-radius: ${rem(4)};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    padding: 0 ${rem(40)};
    height: ${rem(45)};
    margin-right: ${rem(20)};
    margin-bottom: ${rem(10)};
    cursor: pointer;
    box-shadow: 0 0 10px ${({ theme }) => theme.colors.dark};
`;

export const ButtonTicket = styled(Button)<{ colors: IColors }>`
    background: ${(props) => props.colors?.colorButton};
    color: ${({ theme }) => theme.colors.white};
`;

export const ButtonPartner = styled(Button)<{ colors: IColors }>`
    background: ${({ theme }) => theme.colors.white};
    color: ${(props) => props.colors?.colorLink};
`;

export const Lecturers = styled.div`
    color: ${({ theme }) => theme.colors.white};
    position: relative;
    margin-top: auto;
    padding: ${rem(20)} ${rem(15)} ${rem(30)} ${rem(30)};
`;

export const Lecturer = styled.div`
    float: left;
`;

export const LecturersTitle = styled.span`
    display: block;
    font-size: ${({ theme }) => theme.fontSizes.h6};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    padding-bottom: ${rem(10)};
`;

export const LecturersList = styled.span``;

export const LecturerName = styled.span``;

export const LecturerSurname = styled.span`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
`;

export const LecturerNext = styled.div`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    float: left;
`;